import { gql } from '@apollo/client';
import { WorkspaceFieldsFragment } from './fragments';
import { ErrorFragment } from '../fragments';

export const WORKSPACE_CREATE = gql`
  mutation workspaceCreate($input: WorkspaceCreateInput!) {
    workspaceCreate(input: $input) {
      entity {
        ...WorkspaceEntity
      }
      errors {
        field
        messages
      }
    }
  }
  ${WorkspaceFieldsFragment}
`;

export const WORKSPACE_EDIT = gql`
  mutation workspaceEdit($input: WorkspaceEditInput!) {
    workspaceEdit(input: $input) {
      entity {
        ...WorkspaceEntity
      }
      errors {
        field
        messages
      }
    }
  }
  ${WorkspaceFieldsFragment}
`;

export const WORKSPACE_ADD_ANALYSES = gql`
  mutation workspaceAddAnalyses($input: WsAddAnalysesInput!) {
    wsAddAnalyses(input: $input) {
      entity {
        ...WorkspaceEntity
      }
      errors {
        field
        messages
      }
    }
  }
  ${WorkspaceFieldsFragment}
`;

export const WORKSPACE_DELETE_ANALYSES = gql`
  mutation workspaceDeleteAnalysis($input: WsDeleteAnalysisInput!) {
    wsDeleteAnalysis(input: $input) {
      entity {
        ...WorkspaceEntity
      }
      errors {
        field
        messages
      }
    }
  }
  ${WorkspaceFieldsFragment}
`;

export const WORKSPACE_REPLACE_ANALYSES = gql`
  mutation workspaceReplaceAnalyses($input: WorkspaceReplaceAnalysisInput!) {
    wsReplaceAnalysis(input: $input) {
      entity {
        ...WorkspaceEntity
      }
      newAnalysisId
      warningMessage
      errors {
        ...ErrorFields
      }
    }
  }
  ${WorkspaceFieldsFragment}
  ${ErrorFragment}
`;

export const WORKSPACE_DELETE = gql`
  mutation workspaceDelete($input: WorkspaceDeleteInput!) {
    workspaceDelete(input: $input) {
      message
      errors {
        field
        messages
      }
    }
  }
`;

export const WORKSPACE_TO_SCRATCHPAD = gql`
  mutation workspaceToScratchpad($input: WorkspaceScratchpadConvertInput!) {
    result: workspaceScratchpadConvert(input: $input) {
      scratchpad {
        id
        title
      }
      errors {
        ...ErrorFields
      }
    }
  }
  ${ErrorFragment}
`;
